import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { CryptoService } from '../crypto.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-t-decode-text',
  templateUrl: './t-decode-text.component.html',
  styleUrls: ['../topic-style.css', './t-decode-text.component.css']
})
export class TDecodeTextComponent extends GeneralTeacherComponent {

  method: string;
  keyN: number;
  keyS: string = " ".repeat(26);
  get keyP() {
    if (this.method == "caesar" || this.method == "skytale") {
      return this.keyN;
    }
    if (this.method == "monoalphabetic" || this.method == "vignereLetters" || this.method == "vignereDigits") {
      return this.keyS;
    }
  }

  set keyP(value: any) {
    if (this.method == "caesar" || this.method == "skytale") {
      if (value || value == 0) {
        this.keyN = +value;
      } else {
        this.keyN = undefined;
      }
    }
    if (this.method == "monoalphabetic" || this.method == "vignereLetters" || this.method == "vignereDigits") {
      if (value) {
        this.keyS = value;
      } else {
        this.keyS = undefined;
      }
    }
  }
  plainText: string;
  cipherText: string;
  modus: string = "normal";
  text: any;

  constructor(protected topicsService: TopicService, protected activatedRoute: ActivatedRoute, public cryptoService: CryptoService, protected http: HttpClient) {
    super(topicsService, activatedRoute);
    this.type = "decodeText"
    this.loadText();
    this.title = this.get("decodeText");
  }

  /** loads the text to generate words from */
  loadText(): Promise<any> {
    let textFile = "./assets/text_" + this.topicService.getLanguage() + ".txt";
    let self = this;
    return new Promise((resolve, reject) => {
      this.http
        .get<string>(textFile)
        .subscribe(response => {
          self.text = response;
          resolve(true);
        })
    })
  }

  /** sets information based on configuration */
  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.keyS = " ".repeat(26);
    this.method = this.configuration.typespecifics.method;
    if (this.method == "vignere") {
      if (this.configuration.typespecifics.key.includes("0") || this.configuration.typespecifics.key.includes("1")) {
        this.method = "vignereDigits";
      } else {
        this.method = "vignereLetters";
      }
    }
    this.keyP = this.configuration.typespecifics.key;
    this.cipherText = this.configuration.typespecifics.text;
    this.modus = this.configuration.typespecifics.modus;
    this.plainText = this.cryptoService.decode(this.method, this.keyP, this.cipherText);
    if (this.method == "skytale") {
      this.plainText = this.plainText.replace(/-/gi, " ");
    }

  }


  generateDefinition(): any {
    let definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/decrypt.png";
    definition.level = (this.modus == 'highlight' ? 1 : (this.modus == 'normal' ? 2 : 3))
    definition.key = "crypto%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};
    definition.typespecifics.method = this.method;
    if (this.method == "vignereLetters" || this.method == "vignereDigits") {
      definition.typespecifics.method = "vignere";
    }
    definition.typespecifics.key = this.keyP;
    definition.typespecifics.text = this.cipherText.trim();
    if (this.method == 'skytale') {
      definition.typespecifics.text = this.cipherText.trim().replace(/ /gi, "-");
    }
    definition.typespecifics.modus = this.modus;
    definition.key = definition.key.concat("%", this.method.toString(), "%", this.keyP, "%", this.cipherText.slice(0, 20));

    return definition;
  }

  reset() {
    super.reset();
    this.title = this.get("decodeText");
    this.method = undefined;
    this.keyP = undefined;
    this.keyN = undefined;
    this.keyS = " ".repeat(26);
    this.plainText = "";
    this.cipherText = "";
    this.modus = "normal";
  }

  /**
   * Normalizs the texts and the keys and computes the cipher text
   */
  onChangeEncoding() {
    if (this.plainText) {
      if (this.method == "vignereDigits") {
        this.plainText = this.cryptoService.normalizeVignereKeys(this.plainText, 'digits');
      } else {
        this.plainText = this.cryptoService.normalizeText(this.plainText);
      }
    }
    if (this.method && (this.keyP || this.keyP == 0) || this.method == 'polybius' || this.method == 'pigpen' || this.method == 'atbash' || this.method == 'morse') {
      switch (this.method) {
        case "caesar": {
          if (!(typeof this.keyP == "number")) {
            this.keyP = undefined;
          } else {
            this.keyP = this.keyP % 26;
            if (this.keyP < 0) {
              this.keyP += 26;
            }
          }
          break;
        }
        case "skytale": {
          this.keyP = Math.min(this.keyP, 10);
          break;
        }
        case "monoalphabetic": {
          if (!(typeof this.keyP == "string")) {
            this.keyP = " ".repeat(26);
          }
          break;
        }
        case "vignereLetters": {
          //this.keyP = this.keyP.slice(0, 8);
          this.keyP = this.cryptoService.normalizeVignereKeys(this.keyP, 'letters'); break;
        }

        case "vignereDigits": {
          this.keyP = this.cryptoService.normalizeVignereKeys(this.keyP, 'digits'); break;
        }
      }
      if (this.plainText) {
        this.cipherText = this.cryptoService.encode(this.method, this.keyP, this.plainText);
      }
    }
  }

  generate() {
    let methodCode = Math.floor(Math.random() * 8);
    this.keyN = Math.floor(Math.random() * 26);
    this.generateText();
    switch (methodCode) {
      case 0: this.method = "caesar"; break;
      case 1: this.method = "morse"; break;
      case 2: this.method = "pigpen"; break;
      case 3: this.method = "monoalphabetic"; this.generateKey(); break;
      case 4: this.method = "skytale"; this.keyN = Math.ceil(this.keyN / 4 + 1); break;
      case 5: this.method = "polybius"; break;
      case 6: {
        this.method = "vignereLetters";
        let phrases = this.text.text.split(/[.!?]/).map(v => v.trim()).filter(v => v.trim().length > 0).filter(v => v.length < 150);
        let index = Math.floor(Math.random() * phrases.length);
        this.keyS = phrases[index].split(" ").filter(v => v.length > 3)[0];
        break;
      }
      case 7: this.method = "vignereDigits"; this.keyS = "1001"; break;

    }
    this.generateText();
    if (this.method == "vignereDigits") {
      this.generate01();
    }
    this.title = this.get("decodeText");
    this.modus = "normal";
    this.onChangeEncoding();
  }

  /**
   * generates a Text
   */
  generateText() {
    let phrases = this.text.text.split(/[.!?]/).map(v => v.trim()).filter(v => v.trim().length > 0).filter(v => v.length < 150);
    let index = Math.floor(Math.random() * phrases.length);
    this.plainText = this.cryptoService.normalizeText(phrases[index]);
    this.onChangeEncoding();
  }

  /**
   * generates a monoalphabetical key
   */
  generateKey() {
    this.keyS = "";
    let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    while (chars.length > 0) {
      let i = Math.floor(Math.random() * chars.length);
      this.keyS = this.keyS.concat(chars[i]);
      chars.splice(i, 1);
    }
    this.onChangeEncoding();
  }

  /**
   * generates a string of 0 and 1 of length 20
   */
  generate01() {
    this.plainText = "";
    for (let i = 0; i < 20; i++) {
      this.plainText = this.plainText.concat(Math.random() > 0.5 ? "1" : "0");
    }
    this.onChangeEncoding();
  }

  getMethodDescription() {
    switch (this.method) {
      case "caesar": return this.get("useCaesar");
      case "polybius": return this.get("usePolybius");
      case "skytale": return this.get("useSkytale");
      case "monoalphabetic": return this.get("useMonoalphabetic");
      case "vignere": return this.get("useMask");
      case "vignereDigits": return this.get("useMask");
      case "vignereLetters": return this.get("useMask");
      case "pigpen": return this.get("usePigpen");
      case "atbash": return this.get("useAtbash");
      case "morse": return this.get("useMorse");
    }
  }

}
